import React from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

interface ResourceSearchProps {
  placeholder?: string;
  onSearch: (value: string) => void;
  initialValue?: string;
}

export const ResourceSearch: React.FC<ResourceSearchProps> = ({
  placeholder = 'Buscar...',
  onSearch,
  initialValue = '',
}) => {
  const [value, setValue] = React.useState(initialValue);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  return (
    <Form onSubmit={handleSubmit}>
      <InputGroup>
        <Form.Control
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <Button type="submit" variant="primary" aria-label="Buscar">
          <span className="d-none d-sm-inline">Buscar</span>
          <span className="d-inline d-sm-none" aria-hidden="true">🔍</span>
        </Button>
      </InputGroup>
    </Form>
  );
};
